import { PublicationShortname } from "src/app/auth/serviceIdentifier";
import {
  NLB_AUTH_ORIGIN,
  NLB_STG_AUTH_ORIGIN,
  SESSION_KEY_AUTH_ORIGIN,
  SESSION_KEY_EPAPER_AUTH_ORIGIN,
} from "src/app/data.client";
import { isSessionAuthenticated } from "src/trackers/viewerContext";

function matchesNlbAuthOrigin(value: string | null | undefined): boolean {
  if (!value) return false;
  const lower = value.toLowerCase();
  return lower === NLB_AUTH_ORIGIN || lower === NLB_STG_AUTH_ORIGIN;
}

// Reads epaper_auth_origin first (survives LB2 logout), falls back to auth_origin.
export function isNlbUser(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return (
    matchesNlbAuthOrigin(
      sessionStorage.getItem(SESSION_KEY_EPAPER_AUTH_ORIGIN),
    ) ||
    matchesNlbAuthOrigin(sessionStorage.getItem(SESSION_KEY_AUTH_ORIGIN))
  );
}

// Idempotent — safe to call on every relevant render.
export function persistNlbOriginIfPresent(): void {
  if (typeof window === "undefined") return;
  const raw = sessionStorage.getItem(SESSION_KEY_AUTH_ORIGIN);
  if (raw != null && matchesNlbAuthOrigin(raw)) {
    sessionStorage.setItem(SESSION_KEY_EPAPER_AUTH_ORIGIN, raw);
  }
}

/**
 * True when the current visitor is an NLB patron whose session is no longer
 * valid server-side (expired or logged out). Such patrons must be routed to
 * `/nlb/session-expired` to re-authenticate via NLB eResources — never to a
 * mySPH login they cannot complete. Uses the server verdict (`viewerContext`)
 * rather than the client Lightbox `isAuthenticated`, which only reflects
 * `mysph-sid` cookie presence and stays true after a silent token expiry
 * (EPPR2-3315).
 */
export async function isNlbSessionExpired(
  pubsId: PublicationShortname | null,
): Promise<boolean> {
  if (!isNlbUser() || pubsId == null) {
    return false;
  }

  return !(await isSessionAuthenticated(pubsId));
}
